export default __webpack_public_path__ + "static/media/flightUpIcon.8e567f0a.svg";